<template>
  <span class="svg-icon-add-item">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1115_96208)">
      <path d="M26.6667 53.3337H18.1001C10.4667 53.3337 6.66675 49.5337 6.66675 41.9003V18.1003C6.66675 10.467 10.4667 6.66699 18.1001 6.66699H33.3334C40.9667 6.66699 44.7668 10.467 44.7668 18.1003" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M61.9001 73.3337H46.6667C39.0334 73.3337 35.2334 69.5337 35.2334 61.9003V38.1003C35.2334 30.467 39.0334 26.667 46.6667 26.667H61.9001C69.5334 26.667 73.3334 30.467 73.3334 38.1003V61.9003C73.3334 69.5337 69.5334 73.3337 61.9001 73.3337Z" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M49.5667 50H60.4333" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M55 55.4331V44.5664" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_1115_96208">
      <rect width="80" height="80" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
